import useResponsiveRedux from '../../Hooks/useResponsiveRedux';
import MostWinsWrestlerMobile from '../../../pages/Mobile/Stats/MostWinsWrestlerMobile';
import MostWinsStats from '../../../pages/MostWinsStats';

const MostWinsWrestlerResponsive = () => {
    const { isMobile } = useResponsiveRedux(); 
    return isMobile ? <MostWinsWrestlerMobile /> : <MostWinsStats />;
}; 

export default MostWinsWrestlerResponsive;